export enum UserRole {
    SuperAdmin = 1,
    Distributor = 10,
    Client = 20
}